import { TraitRegistryCategory } from '../../TraitRegistryCategory';
import { TraitTypeImg } from '../../traitTypes/TraitTypeImg';
import { TraitTypeSwitchButtons } from '../../traitTypes/TraitTypeSwitchButtons';
import { TraitTypeNumericWithSlider } from '../../traitTypes/TraitTypeNumericWithSlider';
import { TraitTypeNoValue } from '../../traitTypes/TraitTypeNoValue';
export class TraitRegistryImage extends TraitRegistryCategory {
    label = 'Image';
    constructor(parent) {
        super(parent);
        super.init();
    }
    imageWidth = () => new TraitTypeNumericWithSlider({
        /*    label: 'Bildbreite',
        min: 0,
        max: 1000, */
        default: 20,
        css: ({ at }) => [{ k: 'width', v: at.scaledValue }],
    });
    imageHeight = () => new TraitTypeNumericWithSlider({
        /*   label: 'Bildhöhe',
        min: 0,
        max: 1000, */
        default: 10,
        css: ({ at }) => [{ k: 'height', v: at.scaledValue }],
        //  css: ({ at }) => [{ k: 'height', v: at.scaledValue }]
    });
    imageResponsive = () => new TraitTypeNoValue({
        /*   label: 'Responsive Image', */
        css: ({ at }) => [
            { k: 'width', v: '100%' },
            { k: 'height', v: 'auto' },
            { k: 'maxWidth', v: at.aspect.scaledValueOf.imageWidth },
            { k: 'maxHeight', v: at.aspect.scaledValueOf.imageHeight },
        ], // make images responsive
    });
    imageZoomable = () => new TraitTypeSwitchButtons( /*{
      label: 'Bild Zoombar',
      select: [
        [1, 'ja'],
        [0, 'nein']
      ],
      default: 0
    }*/);
    imageFile = new TraitTypeImg({
        /*  label: 'Bilddatei', */
        init: () => ({ type: 'img' }) /* !! CANNOT BE MOVED TO META, because of legacy images !!! */,
    });
}
